import { graphql } from 'react-relay';

export const upsertBusinessAnswerQuery = graphql`
  mutation businessAnswerUpsertMutation(
    $surveyAnswerId: String!
    $bmanTin: String!
    $isCompleted: Boolean!
    $isStartBusinessDirectly: YesNoEtc
    $hasPreviousBusinessInSameIndustry: YesNoBlank
    $isSmallBossOrMachineOwner: YesNoBlank
    $isNewSignboard: NewSignboardType
    $hasTakingOverEmployees: TakingOverEmployeesType
    $takingOverEmployees: [SurveyEmployeeInput!]
    $businessPlaceType: BusinessPlaceType
    $businessPlaceTypeComment: String
    $isWorkingAtRegisteredAddress: YesNoBlank
    $isFirstLocation: YesNoBlankAddressUnknown
    $locations: [LocationInput!]
    $hasPartnerAtTheTimeOfEstablishment: PartnerAtEstablishmentType
  ) {
    upsertBusinessAnswer(
      surveyAnswerId: $surveyAnswerId
      bmanTin: $bmanTin
      isCompleted: $isCompleted
      isStartBusinessDirectly: $isStartBusinessDirectly
      hasPreviousBusinessInSameIndustry: $hasPreviousBusinessInSameIndustry
      isSmallBossOrMachineOwner: $isSmallBossOrMachineOwner
      isNewSignboard: $isNewSignboard
      hasTakingOverEmployees: $hasTakingOverEmployees
      takingOverEmployees: $takingOverEmployees
      businessPlaceType: $businessPlaceType
      businessPlaceTypeComment: $businessPlaceTypeComment
      isWorkingAtRegisteredAddress: $isWorkingAtRegisteredAddress
      isFirstLocation: $isFirstLocation
      locations: $locations
      hasPartnerAtTheTimeOfEstablishment: $hasPartnerAtTheTimeOfEstablishment
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertIsStartBusinessDirectly = graphql`
  mutation businessIsStartBusinessDirectlyMutation($surveyAnswerId: String!, $bmanTin: String!, $isCompleted: Boolean!, $isStartBusinessDirectly: YesNoEtc) {
    upsertBusinessAnswer(surveyAnswerId: $surveyAnswerId, bmanTin: $bmanTin, isCompleted: $isCompleted, isStartBusinessDirectly: $isStartBusinessDirectly) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertSameIndustry = graphql`
  mutation businessSameIndustryMutation($surveyAnswerId: String!, $bmanTin: String!, $isCompleted: Boolean!, $hasPreviousBusinessInSameIndustry: YesNoBlank) {
    upsertBusinessAnswer(
      surveyAnswerId: $surveyAnswerId
      bmanTin: $bmanTin
      isCompleted: $isCompleted
      hasPreviousBusinessInSameIndustry: $hasPreviousBusinessInSameIndustry
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertSmallBossOrMachineOwner = graphql`
  mutation businessSmallBossOrMachineOwnerMutation(
    $surveyAnswerId: String!
    $bmanTin: String!
    $isCompleted: Boolean!
    $isSmallBossOrMachineOwner: YesNoBlank
  ) {
    upsertBusinessAnswer(surveyAnswerId: $surveyAnswerId, bmanTin: $bmanTin, isCompleted: $isCompleted, isSmallBossOrMachineOwner: $isSmallBossOrMachineOwner) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertNewSignboard = graphql`
  mutation businessNewSignboardMutation($surveyAnswerId: String!, $bmanTin: String!, $isCompleted: Boolean!, $isNewSignboard: NewSignboardType) {
    upsertBusinessAnswer(surveyAnswerId: $surveyAnswerId, bmanTin: $bmanTin, isCompleted: $isCompleted, isNewSignboard: $isNewSignboard) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertBusinessPartner = graphql`
  mutation businessPartnerMutation(
    $surveyAnswerId: String!
    $bmanTin: String!
    $isCompleted: Boolean!
    $hasPartnerAtTheTimeOfEstablishment: PartnerAtEstablishmentType
  ) {
    upsertBusinessAnswer(
      surveyAnswerId: $surveyAnswerId
      bmanTin: $bmanTin
      isCompleted: $isCompleted
      hasPartnerAtTheTimeOfEstablishment: $hasPartnerAtTheTimeOfEstablishment
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertTakingOverEmployees = graphql`
  mutation businessTakingOverEmployeesMutation(
    $surveyAnswerId: String!
    $bmanTin: String!
    $isCompleted: Boolean!
    $hasTakingOverEmployees: TakingOverEmployeesType
    $takingOverEmployees: [SurveyEmployeeInput!]
  ) {
    upsertBusinessAnswer(
      surveyAnswerId: $surveyAnswerId
      bmanTin: $bmanTin
      isCompleted: $isCompleted
      hasTakingOverEmployees: $hasTakingOverEmployees
      takingOverEmployees: $takingOverEmployees
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertWorkingAtRegisteredAddress = graphql`
  mutation businessWorkingAtRegisteredAddressMutation(
    $surveyAnswerId: String!
    $bmanTin: String!
    $isCompleted: Boolean!
    $isWorkingAtRegisteredAddress: YesNoBlank
  ) {
    upsertBusinessAnswer(
      surveyAnswerId: $surveyAnswerId
      bmanTin: $bmanTin
      isCompleted: $isCompleted
      isWorkingAtRegisteredAddress: $isWorkingAtRegisteredAddress
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertBusinessPlaceType = graphql`
  mutation businessPlaceTypeMutation(
    $surveyAnswerId: String!
    $bmanTin: String!
    $isCompleted: Boolean!
    $businessPlaceType: BusinessPlaceType
    $businessPlaceTypeComment: String
  ) {
    upsertBusinessAnswer(
      surveyAnswerId: $surveyAnswerId
      bmanTin: $bmanTin
      isCompleted: $isCompleted
      businessPlaceType: $businessPlaceType
      businessPlaceTypeComment: $businessPlaceTypeComment
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertIsFirstLocation = graphql`
  mutation businessIsFirstLocationMutation(
    $surveyAnswerId: String!
    $bmanTin: String!
    $isCompleted: Boolean!
    $isFirstLocation: YesNoBlankAddressUnknown
    $locations: [LocationInput!]
  ) {
    upsertBusinessAnswer(
      surveyAnswerId: $surveyAnswerId
      bmanTin: $bmanTin
      isCompleted: $isCompleted
      isFirstLocation: $isFirstLocation
      locations: $locations
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;

export const upsertLocations = graphql`
  mutation businessLocationsMutation(
    $surveyAnswerId: String!
    $bmanTin: String!
    $isCompleted: Boolean!
    $isFirstLocation: YesNoBlankAddressUnknown
    $locations: [LocationInput!]
  ) {
    upsertBusinessAnswer(
      surveyAnswerId: $surveyAnswerId
      bmanTin: $bmanTin
      isCompleted: $isCompleted
      isFirstLocation: $isFirstLocation
      locations: $locations
    ) {
      result
      errors {
        code
        message
      }
    }
  }
`;
